const isSpaceOrEnterKey = (event) => {
    return [" ", "Enter", "Spacebar"].includes(event.key);
};
const isKeyboardEvent = (event) => {
    return "code" in event;
};
const isSpaceKey = (event) => {
    return isKeyboardEvent(event) && event.code === SPACE_KEY;
};
const isEnterKey = (event) => {
    return isKeyboardEvent(event) && event.code === ENTER_KEY;
};
const SPACE_KEY = "Space";
const ENTER_KEY = "Enter";

export { isEnterKey, isKeyboardEvent, isSpaceKey, isSpaceOrEnterKey };
//# sourceMappingURL=keyboard.js.map
